import { atom } from "recoil";

export const tournamentsAddModalStore = atom({
	key: "tournamentsAddModalStore",
	default: {
		show: false,
		loaded: false,
		name: "",
		currentOption: {
			tournamentType: [
				{ value: "sum_of_bets", label: "sum of bets" },
				{ value: "highest_coefficient", label: "highest coefficient" },
				{ value: "number_of_bets", label: "number of bets" },
				{ value: "sum_of_winnings", label: "sum of winnings" }
			],
			periodType: [
				{ value: "daily", label: "daily" },
				{ value: "monthly", label: "monthly" },
				{ value: "weekly", label: "weekly" }
			],
			translationType: [
				{ value: "internation", label: "internation" },
				{ value: "local", label: "local" },
			],
		},
		modalType: "",
		recurrence: "",
		translationType: "",
		tournamentType: "",
		periodType: "",
		game_ids: [],
		provider_ids: [],
		winners: "",
		template_id: null,
		prize_pool: "",
		from: "",
		to: "",
		min_bet: "",
		status: "active",
		banner: null,
		slug: "",
		vip_level: null,
		deposit_count: "",
		promo_scope: "tournament_games",
		configBot: {
			enabled: false,
			bots: [],
		},
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		prizeDistribution: [{ place: 1, prize: "" }],
		distributionMethod: "manual",
	},
});
